import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { TextButton } from '../typography';
import { ThemeContext } from '../../theming';

function CustomButton({ onClick, type="button", children, size = 'md', sizeText = 0, disabled = false,
	className = 'w-100 btn-primary-custom', styleText = null }) {
	const app = useContext(ThemeContext);
	const { body12 } = app.theme.font
	const button = {
		background: app.theme.primary,
		color: app.theme.textDark,
		borderColor: app.theme.primary,
		borderRadius: '7px'
	};
	return (
		<Button type={type} disabled={disabled} className={className} onClick={onClick} style={button} size={size}>
			<TextButton bold size={sizeText === 0 ? body12 : sizeText} type='primary' style={{...styleText}}>{children}</TextButton>
		</Button>
	);
}

export default CustomButton;
